import { ref } from "vue";

export const displayTrailer = ref(false)